import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';

import { LciaScore, FetchLciaScoresParams } from './types';

const fetchLciaScores = async (params: FetchLciaScoresParams) => {
  const { data } = await api.get(`/spold/lcia_results`, { params });
  return data;
};

const useLciaScores = (dataset_id: number, method_id?: number, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<LciaScore[], AxiosError>({
    queryKey: ['lciaData', dataset_id, version, system_model, method_id],
    queryFn: () => fetchLciaScores({ dataset_id, method_id: method_id as number, version, system_model }),
    enabled: !!dataset_id && dataset_id !== -1 && method_id !== undefined,
  });
};

export default useLciaScores;
